<template>
	<el-menu mode="vertical" default-active="1" class="el-menu-vertical-demo">
      <el-menu-item-group title="Group One">
        <el-menu-item index="1"><i class="el-icon-message"></i>Navigator One</el-menu-item>
        <el-menu-item index="2"><i class="el-icon-message"></i>Navigator Two</el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group title="Group Two">
        <el-menu-item index="3"><i class="el-icon-message"></i>Navigator Three</el-menu-item>
        <el-menu-item index="4"><i class="el-icon-message"></i>Navigator Four</el-menu-item>
      </el-menu-item-group>
    </el-menu>
</template>
<script>
  import Vue from 'vue'
  import {Menu, MenuItem, MenuItemGroup} from 'element-ui'
  Vue.use(Menu)
  Vue.use(MenuItem)
  Vue.use(MenuItemGroup)
  export default {
    name: 'settings-menu',
    components: {
      [Menu.name]: Menu,
      [MenuItem.name]: MenuItem,
      [MenuItemGroup.name]: MenuItemGroup
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/SettingsMenu.vue